import styled from 'styled-components';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { VisualPickerWrapper } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker.styles';

export const StyledVisualPicker = styled(VisualPicker)({
  [VisualPickerWrapper]: {
    width: 80,
    paddingRight: 0,
  },
});
